module.exports = __webpack_public_path__ + "static/media/Edmonton_Oilers.3245d4e5.svg";